/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ClassificationsControllerFindAllQueryResponse, ClassificationsControllerFindAllPathParams, ClassificationsControllerFindAllQueryParams, ClassificationsControllerFindAll401, ClassificationsControllerFindAll403 } from "../../models/documentClassificationsController/ClassificationsControllerFindAll";

function getClassificationsControllerFindAllUrl(documentId: ClassificationsControllerFindAllPathParams["documentId"], renditionId: ClassificationsControllerFindAllPathParams["renditionId"]) {
  const res = { method: 'GET', url: `/api/v1/documents/${documentId}/renditions/${renditionId}/classifications` as const }  
  return res
}

/**
 * @description Returns classifications with JSON:API pagination, sorting, filtering, and includes. Use ?include=results to include classification results.
 * @summary List all classifications for a rendition
 * {@link /api/v1/documents/:documentId/renditions/:renditionId/classifications}
 */
export async function classificationsControllerFindAll(documentId: ClassificationsControllerFindAllPathParams["documentId"], renditionId: ClassificationsControllerFindAllPathParams["renditionId"], params?: ClassificationsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ClassificationsControllerFindAllQueryResponse, ResponseErrorConfig<ClassificationsControllerFindAll401 | ClassificationsControllerFindAll403>, unknown>({ method : "GET", url : getClassificationsControllerFindAllUrl(documentId, renditionId).url.toString(), params, ... requestConfig })  
  return res.data
}